import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface IframeComponentProps {
    srcDoc: any;
    onLoad?:() => void;
}

export const helper = (iframeRef) => {
    const handleLinkClick = (event) => {
        event.preventDefault();
        const id = event.target.getAttribute('href')?.substring(1);
        // @ts-ignore: Unreachable code error
        const element = iframeRef.current?.contentDocument?.getElementsByName(id)[0];
        element?.scrollIntoView({ block: 'center' });
    };

    const iframe = iframeRef.current;
    // @ts-ignore: Unreachable code error
    const iframeDocument = iframe?.contentDocument;

    if (iframeDocument) {
        const links = iframeDocument.querySelectorAll('a[href^="#"]');
        links.forEach((link) => {
            link.addEventListener('click', handleLinkClick);
        });
        return () => {
            links.forEach((link) => {
                link.removeEventListener('click', handleLinkClick);
            });
        };
    }
     // If iframeDocument is undefined, return a no-op function
    return () => {};
}

const IframeComponent = (props:IframeComponentProps) => {
    const {srcDoc, onLoad} = props
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const [t] = useTranslation();

    useEffect(() => {
        const iframe = iframeRef.current;

        if (iframe) {
            const iframeDocument = iframe.contentWindow?.document;

            if (iframeDocument) {
                const divElement = iframeDocument.getElementById('epo_translation_translate_pane');
                if (divElement) {
                    const labelElement = divElement.querySelector('label');
                    if (labelElement) {
                        labelElement.textContent =  t('DOCUMENT_VIEW::LANGUAGE_LABEL');
                    }
                }
            }
        }
    }, [t]);

    useEffect(() => {
        setTimeout(() => {
              const handleLinkClick = (event) => {
                event.preventDefault();
                const id = event.target.getAttribute('href').substring(1);
                // @ts-ignore: Unreachable code error
                const element = iframeRef.current.contentDocument.getElementsByName(id)[0];
                element.scrollIntoView({ block: 'center' });
            };

            const iframe = iframeRef.current;
            // @ts-ignore: Unreachable code error
            const iframeDocument = iframe?.contentDocument;

            if (iframeDocument) {
                const links = iframeDocument.querySelectorAll('a[href^="#"]');
                links.forEach((link) => {
                    link.addEventListener('click', handleLinkClick);
                });
                return () => {
                    links.forEach((link) => {
                        link.removeEventListener('click', handleLinkClick);
                    });
                };
            }
        }, 1000);
    }, [srcDoc]);

    return (
        <iframe
            width="100%"
            height="700px"
            title="XML"
            ref={iframeRef}
            srcDoc={srcDoc}
            className="border-bottom border-ds-light"
            onLoad={onLoad}
        />
    );
};

export default IframeComponent;
